import React, { useEffect, useRef, useState } from 'react'
import FilterOptions from '../FilterOptions'
import FlightDetails from '../FlightDetails'
import './flight-details-list.scss'
import MESSAGES from '../../constants/Messages'
import { useTranslation } from 'react-i18next'
import { addError, pushEventInstantConfirmation } from '../../utils/analytics'
import { NOTIFICATION_MESSAGE_TYPE, SERVICES } from '../../constants'
import LoadingIndicator from '../LoadingIndicator'
import { sendAlternateRouteEnquiryEmail } from './AlternateRouteEnquiryPopup'
import { Alert } from '../../common/Alert'
import { useSelector } from 'react-redux'
import { getBase64Decoded, getBase64Encoded, getFromSessionStorage, setToSessionStorage } from '../../utils/StorageUtils'
import sessionKeys from '../../constants/sessionKeys'


const FlightDetailsList = ({
	setEnquiredPresent,
	airportList,
	fastTrackList,
	selectedDate,
	response,
	setInstantConfimation,
	isFastTrackEnabled,
	showDropoffPickup,
	selectedDestination,
	selectedOrigin,
	shippingDate,
	shippingItem,
	additionalSccs,
	totalGrossWeight,
	totalVolume,
	depAirport,
	overrideRates,
	searchFormData
}) => {

	const { t, i18n } = useTranslation(['labels', 'errors'])
	const prevAirportList = usePrevious(airportList);
	const [updatedAirportList, setUpdatedAirportList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [notificationType, setNotificationType] = useState('')
	const [notificationMessage, setNotificationMessage] = useState('')
	const [airportMailData, setAirportMailData] = useState(new Map());


	const masterData = useSelector(state => state.masterData);

	useEffect(() => {
		const sessionData = getFromSessionStorage(sessionKeys.ROUTE_ENQUIRY_AIRPORT_MAIL_DATA);
		if (sessionData) {
			const decodedSessionData = getBase64Decoded(sessionData);
			if (decodedSessionData) {
				setAirportMailData(new Map(JSON.parse(decodedSessionData)))
			}
		}
	}, [])

	useEffect(() => {
		if (airportMailData && airportMailData.size > 0) {
			const serialized = JSON.stringify(Array.from(airportMailData.entries()));
			setToSessionStorage(sessionKeys.ROUTE_ENQUIRY_AIRPORT_MAIL_DATA, getBase64Encoded(serialized));
		}
	}, [airportMailData]);

	function usePrevious(value) {
		const ref = useRef();
		useEffect(() => {
			ref.current = value;
		}, [value]);
		return ref.current;
	}

	useEffect(() => {
		if (response?.error?.errorData) {
			setNotificationMessage(response?.error?.errorData);
			setNotificationType(NOTIFICATION_MESSAGE_TYPE.ERROR);
		}
	}, [response]);

	/*useEffect(() => {
		console.log('airportList', airportList, prevAirportList);
		if(JSON.stringify(airportList) !== JSON.stringify(prevAirportList)){
		if(airportList.length > 0 && response && response.isLoading === false){
			let airportsFilteredByValidTotalRate = airportList.filter((airport => airport.ratingDetails[0].totalRate !== 0))
			if(airportsFilteredByValidTotalRate.length === 0){
				pushEventInstantConfirmation('No');
			}
			else{
				let airportsFilteredByNoInstantData = airportList.filter((airport) => 
				airport.overBookingAllowed !== false || airport.overHangShipment !== false 
				|| airport.bigShipment !== false || airport.isForceQueued !== false)
				if(airportsFilteredByNoInstantData.length !== 0){
					pushEventInstantConfirmation('No');
				}
				else{
					pushEventInstantConfirmation('Yes');
				}
			}
		}
		else if(airportList.length === 0 && response && response.isLoading === false){
			console.log('pushEventInstantConfirmation - No');
			pushEventInstantConfirmation('No');
		}
	}
	},[airportList])*/

	const getFlightDetails = (flightSelected) => {
		let selectedFlight = flightSelected
		const totalSurcharge = calculateTotalSurcharge(selectedFlight)
		if (totalSurcharge !== 0) {
			selectedFlight.ratingDetails[0].totalSurcharge = totalSurcharge
		}
		return selectedFlight
	}

	const calculateTotalSurcharge = (flightSelected) => {
		let totalSurcharge = 0.0
		if (
			flightSelected.ratingDetails &&
			flightSelected.ratingDetails.length > 0 &&
			flightSelected.ratingDetails[0].otherChargeDetails &&
			flightSelected.ratingDetails[0].otherChargeDetails.length > 0
		) {
			flightSelected.ratingDetails[0].otherChargeDetails.forEach(function (
				otherCharge
			) {
				if (otherCharge.chargeAmount) {
					totalSurcharge = totalSurcharge + otherCharge.chargeAmount
				}
			})
		}
		return totalSurcharge
	}

	const handleRoutingEnquiryLinkClick = async () => {
		await sendAlternateRouteEnquiryEmail(
			selectedDestination,
			selectedOrigin,
			shippingDate,
			shippingItem,
			setNotificationMessage,
			setNotificationType,
			additionalSccs,
			response?.error?.description,
			totalGrossWeight,
			totalVolume,
			setIsLoading,
			t
		)
	}

	const getNoFlightErrorMsgWithHyperLink = (response) => {
		const errorMsgToDisplay = response.error
			? t(response.error.description, { ns: "errors" })
			: t(MESSAGES.NO_FLIGHTS, { ns: "errors" });
		const errorCodeFromResponse = response?.error?.errorCode;
		let isMailNeededCase = 'N';
		const isValidErrorCase = response.error &&
			["ER044", "ER047", "ER046"].includes(errorCodeFromResponse);
		if (isValidErrorCase) {
			const { countryCode, code, enquiryOptionEnabled } = depAirport || {};
			const sessionMailData = airportMailData?.get(code);
			if (sessionMailData) {
				isMailNeededCase = sessionMailData;
			} else {
				let countryCodeToCheck = countryCode;
				const { regionMaster, airportMaster, countryMaster } = masterData || {};
				if (!countryCodeToCheck) {
					countryCodeToCheck = airportMaster?.at(0)?.countryCode;
				}
				if (countryCode) {
					const country = countryMaster?.find(con => con?.countryCode === countryCode);
					if (country && country?.regionCode) {
						const region = regionMaster?.find(reg => reg?.regionCode === country.regionCode);
						if (region?.enquiryOptionEnabled) {
							isMailNeededCase =
								region.enquiryOptionEnabled;
						} else if (country?.enquiryOptionEnabled) {
							isMailNeededCase =
								country.enquiryOptionEnabled;
						} else {
							isMailNeededCase =
								enquiryOptionEnabled;
						}
					}
				}
				setAirportMailData(prev => {
					const newMap = new Map(prev);
					newMap.set(code, isMailNeededCase);
					return newMap;
				})
			}

		}
		return (
			<div className="no-flights-error">
				{errorMsgToDisplay}
				{isValidErrorCase && isMailNeededCase === 'Y' && (
					<button
						className="enquiry-hyperlink link"
						onClick={handleRoutingEnquiryLinkClick}
					>
						{t('BOOKING.ALTERNATE_ROUTE_ENQUIRY_HYPERLINK')}
					</button>
				)}
			</div>
		);
	};

	const handleAlertClose = () => {
		setNotificationMessage('')
		setNotificationType(null)
	}

	return (
		<>
			{isLoading && <LoadingIndicator />}
			<div className='flight-list-details-section'>

				<div className='flight-details portal-col'>
					{/* <div className='fd-header'> */}
					{/* <div className='fd-header__left'> */}
					{/* <div className='fd-header__results'>{`${
						airportList && airportList.length ? airportList.length : 0
					}`}</div>
					&nbsp;
					<div className='fd-header__results'>{t('CHOOSE_FLT.NO.OF.FLTS')}</div> */}
					{/* <div className='flights_count'>
						<div className='fd-header__results'>{`${
							airportList && airportList.length ? airportList.length : 0
						}`}</div>
						&nbsp;
						<div className='fd-header__results'>{`Flights`}</div>
					</div> */}
					{/* <div> */}
					<FilterOptions airportList={airportList} selectedDate={selectedDate} />
					{/* </div> */}
					{/* </div> */}
					{/*<div className="fd-header__right">
					<a className='l-link'>
						<span>Clear Selection</span>
					</a>
				</div>*/}
				</div>
				{notificationMessage && notificationMessage !== "" && (
					<Alert
						showAlert={true}
						message={t(notificationMessage, { ns: "errors" })}
						setTimeout={true}
						onAlertClose={handleAlertClose}
						type={notificationType}
					/>
				)}
				<div className='flight-details__list portal-col'>
					{/* {airportList && airportList.length ? (
						airportList.map((destinationAirport, index) => (
							<FlightDetails
								setEnquiredPresent={setEnquiredPresent}
								destinationAirport={{
									...destinationAirport,
									service: isFastTrackEnabled ? SERVICES.FAST_TRACK : destinationAirport.service, // Update service
								}}
								key={index}
								showChooseButton={true}
								showDropoffPickup={true}
								showRightSection={true}
								showFooter={true}
							/>
						))
					) : (
						<></>
					)} */}

					{airportList && airportList.length ? (
						airportList.map((destinationAirport, index) => {
							// Active override object (only meaningful when FastTrack enabled)
							const activeOverride = isFastTrackEnabled && overrideRates ? overrideRates : null;
							
							return (
								<FlightDetails
									key={`${index}-${isFastTrackEnabled ? (overrideRates?.grandTotal ?? '0') + '-' + (overrideRates?.totalRate ?? '0') : 'def'}`}
									setEnquiredPresent={setEnquiredPresent}
									destinationAirport={{
										...destinationAirport,
										service: isFastTrackEnabled ? SERVICES.FAST_TRACK : destinationAirport.service
									}}
									searchFormData={searchFormData}
									showDropoffPickup={true}
									showRightSection={true}
									showChooseButton={true}
									showFooter={true}
									overrideCurrency={activeOverride?.currency}
									overrideGrandTotal={activeOverride?.grandTotal}
									overrideTotalRate={activeOverride?.totalRate}
								/>
							);
						})
					) : <></>}
				</div>
				{/* </div> */}
				{response && airportList && airportList.length === 0 ? (
					<div className='portal-col'>
						<div className='no-data-container'>
							{response && response.isLoading
								? t(MESSAGES.SEARCHING, { ns: 'errors' })
								: getNoFlightErrorMsgWithHyperLink(response)
							}
						</div>
					</div>
				) : (
					<></>
				)}
			</div>
		</>
	)
}

export default FlightDetailsList